import { Box, CircularProgress } from "@mui/material";
import { StyledLoader } from "./styles";
import { LoderProps } from "./type";

const Loader = ({ size }: LoderProps) => {
  return (
    <StyledLoader>
      <CircularProgress
        size={size || 60}
        sx={{ "svg circle": { stroke: "url(#my_gradient)" } }}
      />
      <Box sx={{ height: "0px !important", visibility: "hidden" }}>
        <svg>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#4E5BA6" />
              <stop offset="100%" stopColor="#717BBC" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
    </StyledLoader>
  );
};

export default Loader;
